<template>
  <div id="header">
      <h1>{{ headertext }}</h1>
  </div>
</template>

<script>
export default {
  name: "Header",
  props: ["headertext"],
};
</script>

<style scoped>
#header {
  margin-left: 20px;
  margin-right: 20px;
}
</style>
